'use client'

import {DictKey, t}      from '@/i18n'
import {usePageContext}  from '@/context/PageContext'

export const useT = () => {
	const {lang} = usePageContext()
	return (key: DictKey) => t(lang, key)
}
